import { Box, CircularProgress, Typography, Chip, Stack, alpha } from '@mui/material';
import { useTranslate } from 'react-admin';

interface AutoApprovalControlProps {
  isLoading: boolean;
  error: any;
  settings: {
    autoOrderApprovalFlag: number;
    orderApprovalGracePeriod: number;
  } | null;
}

// 状態の定義
const FLAG_AUTO_APPROVE = 1;
const FLAG_AUTO_DISAPPROVE = 2;

export const AutoApprovalControl = ({ isLoading, error, settings }: AutoApprovalControlProps) => {
  const translate = useTranslate();

  if (isLoading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', p: 2 }}>
        <CircularProgress size={24} />
      </Box>
    );
  }

  if (error || !settings) {
    return (
      <Typography color="error" sx={{ p: 2 }}>
        自動承認設定の読込失敗
      </Typography>
    );
  }

  // 表示状態の判定ロジック (ビット演算)
  const isApproveEnabled = (settings.autoOrderApprovalFlag & FLAG_AUTO_APPROVE) > 0;
  const isDisapproveEnabled = (settings.autoOrderApprovalFlag & FLAG_AUTO_DISAPPROVE) > 0;

  return (
    <Box sx={{ p: 2, border: '1px solid', borderColor: 'divider', borderRadius: 1 }}>
      <Stack direction="row" spacing={2} alignItems="flex-start">
        <Stack direction="column" alignItems="flex-start">
          <Chip
            label={isApproveEnabled ? '自動承認有効' : '自動承認無効'}
            color={isApproveEnabled ? 'success' : 'error'}
            size="small"
            sx={{
              color: 'white',
              backgroundColor: (theme) =>
                alpha(isApproveEnabled ? theme.palette.success.main : theme.palette.error.main, 0.9)
            }}
          />
          {isApproveEnabled && (
            <Typography variant="body2">
              {translate('resources.settings.fields.orderApprovalGracePeriod')}: {settings.orderApprovalGracePeriod}日
            </Typography>
          )}
        </Stack>

        {/* 右側: 「自動否認チップ」のみ */}
        <Chip
          label={isDisapproveEnabled ? '自動否認有効' : '自動否認無効'}
          color={isDisapproveEnabled ? 'success' : 'error'}
          size="small"
          sx={{
            color: 'white',
            backgroundColor: (theme) =>
              alpha(isDisapproveEnabled ? theme.palette.success.main : theme.palette.error.main, 0.9)
          }}
        />
      </Stack>
    </Box>
  );
};
